module.exports = __webpack_public_path__ + "img/1791994300210.8eb91434.png";